module.exports = __webpack_public_path__ + "img/icon10.b32162e9.png";